// extracted by mini-css-extract-plugin
export default {"orderArea":"Customer_orderArea__GW9ob","orderTop":"Customer_orderTop__ogwRG","actionRow":"Customer_actionRow__2Oexe"};